import {Presentation} from "../../../core/gameflow/controller/Presentation";
import {GameData} from "../../server/data/GameData";

// #253 -> 3rd point
export class FSPauseBetweenSpinsPresentation extends Presentation {

    public checkForActivation(data: GameData): boolean {
        return ((data.raw.nextMode.indexOf("FREESPIN") > -1) || (data.lastFSRound));
    }

    public createPresentation(enableSkip: Function): void {
        enableSkip(true);

        this.timeline.to(this, {
            duration: 0.2
        });
        this.timeline.add(() => {
            this.PresentationState.setInactive();
        });
    }
}